import * as LTE from "#/def/lookup-tables.enums.gen";

export const ADMIN_PANNEL_ACCESS_ROLES = [
  LTE.SifNivoDostopa.ADMIN,
  LTE.SifNivoDostopa.RAZVIJALEC,
  LTE.SifNivoDostopa.BF,
  LTE.SifNivoDostopa.VF,
]
